"use client";
import * as React from "react";
const SvgExternalSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M14.22 8.89v5.33H1.78V1.78H7.1V0H0v16h16V8.89zm-1.26-7.11H9.71V0h6.28v6.28h-1.77V3.04L8.14 9.12 6.9 7.87z" }));
export {
  SvgExternalSharp as default
};
